import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import amplitude from 'amplitude-js';
import smartlookClient from 'smartlook-client';
import Icon from '../../../components/Icon';
import { activateTrial, getLoggedUser } from '../../../actions/api';
import * as types from '../../../constants/ActionTypes';
import filterProps from '../../../utils/filterProps';
class TrialModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: true,
            processing: false,
            callback: () => void 0,
        };
        this.handleCloseModal = () => {
            const { isEnded } = this.props;
            this.setState({ open: false });
            let eventName = '';
            if (isEnded) {
                this.props.dispatch({ type: types.TRIAL_END_MODAL_CLOSED });
                eventName = 'trial-end-modal-closed';
                localStorage.setItem('closeTrialEndModal', String(new Date().getTime()));
            }
            else {
                this.props.dispatch({ type: types.TRIAL_MODAL_CLOSED });
                eventName = 'trial-modal-closed';
            }
            amplitude.getInstance().logEvent(eventName);
            smartlookClient.track(eventName, {});
            // this.props.history.push('/repositories');
        };
        this.handleClick = (callback) => {
            this.setState({
                open: true,
                processing: false,
                callback: callback || (() => void 0),
            });
        };
        this.handleSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState({
                processing: true,
            });
            this.props.dispatch(activateTrial()).then((action) => {
                if (action.type === types.ACTIVATE_TRIAL_SUCCESS) {
                    this.setState({
                        open: false,
                        processing: false,
                    });
                    this.props.dispatch(getLoggedUser()).then((action) => {
                        if (action.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                            // @todo: dirty
                            this.props.dispatch({
                                type: types.LOGGED_USER,
                                payload: action.response.data,
                            });
                        }
                    });
                    this.props.dispatch({
                        type: types.TOGGLE_TRIAL_NEWLY_ACTIVATED,
                    });
                    this.state.callback();
                }
            });
        };
    }
    render() {
        const { t, user, isEnded, ...rest } = filterProps(this.props, [
            'dispatch',
            'history',
            'i18n',
            'lng',
            'location',
            'match',
            'staticContext',
            'tReady',
        ]);
        const { open, processing } = this.state;
        return (_jsxs(Modal, { ...rest, isOpen: open && (isEnded ? !user.trialEndModalClosed : !user.trialModalClosed), children: [_jsx(ModalHeader, { children: isEnded ? (t('upgradeToPro')) : (_jsxs(Trans, { i18nKey: "tryProFree", values: { siteName: t('siteName') }, children: ["Try ", t('siteName'), " PRO for free!"] })) }), _jsxs(ModalBody, { children: [_jsx("p", { className: "text-center", children: isEnded ? (_jsxs(Trans, { i18nKey: "upgradeToModal", values: { siteName: t('siteName') }, children: ["You can still use ", t('siteName'), " for open-source repos but for private ones, you need to upgrade to PRO version."] })) : (_jsxs(Trans, { i18nKey: "limitOfPlan", values: { siteName: t('siteName') }, children: ["Woops, you reached the limit of your current ", _jsx("strong", { children: "open-source" }), " plan.", _jsx("br", {}), "Try ", _jsxs("strong", { children: [t('siteName'), " PRO"] }), " 14 day trial and analyze your private repositories. No credit card required."] })) }), _jsx("p", { children: _jsx("img", { src: "/images/dashboard.gif", alt: "Dashboard", className: "mw-100" }) }), _jsx("h2", { className: "h5 ml-2", children: t('proToGet') }), _jsxs("ul", { className: "plan__features plan__features--highlighted w-75 ml-auto mr-auto", children: [_jsxs("li", { className: "plan__feature", children: [t('publicRepositories'), _jsx("strong", { className: "float-right", children: t('unlimited') })] }), _jsxs("li", { className: "plan__feature", children: [t('privateRepositories'), _jsx("strong", { className: "float-right", children: t('unlimited') })] }), _jsxs("li", { className: "plan__feature", children: [t('prioritySupport'), _jsx(Icon, { name: "check", className: "float-right text-primary" })] })] }), _jsx("div", { className: "text-center mt-5 mb-2", children: isEnded ? (_jsx(Link, { to: "/settings/billing", className: "btn btn-primary ml-md-3 mt-2 mt-md-0", children: _jsxs(Trans, { i18nKey: "activatePro", values: { siteName: t('siteName') }, children: ["Activate ", t('siteName'), " PRO"] }) })) : (_jsxs(Button, { color: "primary", size: "lg", onClick: this.handleSubmit, disabled: processing, children: [!processing ? null : _jsx(Icon, { name: "spinner", fixedWidth: true, spin: true, className: "mr-2" }), _jsxs(Trans, { i18nKey: "activatePro", values: { siteName: t('siteName') }, children: ["Activate ", t('siteName'), " PRO"] })] })) }), _jsx("div", { className: "text-center mb-3", children: _jsx(Button, { onClick: this.handleCloseModal, size: "sm", color: "link", className: "text-muted", children: t('remindMeLater') }) })] })] }));
    }
}
TrialModal.defaultProps = {
    isEnded: false,
};
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
// @ts-expect-error TS2345: Argument of type is not assignable
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TrialModal)));
